module.exports = __webpack_public_path__ + "img/组合 85@2x.cc801e4d.png";